// import React from 'react';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';

// import BannerImg from './bannerimg/BannerImg';
// import TrendingTopics from './trendingtopics/TrendingTopics';
// import SearchBox from './searchbox/Searchbox';
// import Tools from './tools/Tools';
// import VideoTutorial from './videotutorial/VideoTutorial';
// import YoutubePlayer from './youtubeplayer/YoutubeVideos';
// import YoutubeVideos from './youtubeplayer/YoutubeVideos';
// import InfoVideos from './videotutorial/InfoVideos';
// import GuidesPage from './guidecards/GuidesPage';
// import Page from './guidecards/Page';
// import { TextField, IconButton, Container, Box, Button ,Grid} from '@mui/material';

// const MyHome = () => {
//   return (
//     <>

//       <BannerImg />
//       <Grid lg={12}  ml={8} mr={8}>


//           <TrendingTopics />


//           <Page />


//           <Tools />


//           <InfoVideos />



//       </Grid>
//       </>
//       );
// };

//       export default MyHome;

import React, { useState, useEffect } from 'react';
import BannerImg from './bannerimg/BannerImg';
import TrendingTopics from './trendingtopics/TrendingTopics';
import Tools from './tools/Tools';
import InfoVideos from './videotutorial/InfoVideos';
import Page from './guidecards/Page';
import { Grid } from '@mui/material';

const MyHome = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 960);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <BannerImg />
      <Grid container marginLeft={isMobile ? 1 : 12} >
        <Grid item xs={12} marginBottom={isMobile ? '4%' : '1%'} marginTop={isMobile ? '7%' : '2%'} marginLeft={isMobile ? 1 : 0} marginRight={isMobile ? 1 : 0}>
          <TrendingTopics />
        </Grid>
        <Grid item xs={12} marginTop='1%' marginLeft={isMobile ? 1 : 0} marginRight={isMobile ? 1 : 0}>
          <Page />
        </Grid>
        <Grid item xs={12} marginBottom='1%' marginTop={isMobile ? '6%' : '1%'} marginLeft={isMobile ? 1 : 0} marginRight={isMobile ? 1 : 0}>
          <Tools />
        </Grid>
        <Grid item xs={12} marginBottom='1%' marginTop={isMobile ? '7%' : '1%'} marginLeft={isMobile ? 1 : 0} marginRight={isMobile ? 1 : 0}>
          <InfoVideos />
        </Grid>
      </Grid>
    </>
  );
};

export default MyHome;
